<div *ngIf="mobile">
  <ng-container *ngTemplateOutlet="financialsFilterContent"></ng-container>
</div>

<ng-container *ngIf="!mobile">
  <div
    class="filter-item"
    [matMenuTriggerFor]="financialsFilter"
    #trigger="matMenuTrigger"
    [ngClass]="{ active: isActive || isOpen }"
    (menuOpened)="isOpen = true"
    (menuClosed)="isOpen = false"
  >
    <span
      >Financials
      <span *ngIf="checkedCount > 0">({{ checkedCount }})</span></span
    >
    <app-shared-icon name="chevron-down-2"></app-shared-icon>
  </div>

  <mat-menu
    #financialsFilter="matMenu"
    xPosition="after"
    class="filters-mat-menu"
  >
    <div
      class="filter-dropdown pt-2 px-4"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
    >
      <ng-container *ngTemplateOutlet="financialsFilterContent"></ng-container>
      <app-filter-v2-buttons
        *ngIf="!mobile"
        (resetAction)="resetProForma()"
        (applyAction)="closeMenu()"
      ></app-filter-v2-buttons>
    </div>
  </mat-menu>
</ng-container>

<ng-template #financialsFilterContent>
  <div [ngClass]="{ 'grid grid-cols-2 gap-x-4': mobile }">
    <div class="filter-more-item">
      <label class="upper-label" for="capRate">Cap rate</label>
      <app-shared-input label="Min" for="capRate" [value]="capRate || 'any'">
        <input
          id="capRate"
          name="capRate"
          type="number"
          placeholder="No min"
          (change)="handleChanges()"
          [(ngModel)]="capRate"
          min="0"
          (focus)="selectAll($event)"
          inputmode="numeric"
        />
      </app-shared-input>
    </div>

    <div class="filter-more-item">
      <label class="upper-label" for="grossYield">Gross yield</label>
      <app-shared-input
        label="Min"
        for="grossYield"
        [value]="grossYield || 'any'"
      >
        <input
          id="grossYield"
          name="grossYield"
          type="number"
          placeholder="No min"
          (change)="handleChanges()"
          [(ngModel)]="grossYield"
          min="0"
          (focus)="selectAll($event)"
          inputmode="numeric"
        />
      </app-shared-input>
    </div>

    <div class="filter-more-item">
      <label class="upper-label" for="projectROI">Project ROI</label>
      <app-shared-input
        label="Min"
        for="projectROI"
        [value]="projectROI || 'any'"
      >
        <input
          id="projectROI"
          name="projectROI"
          type="number"
          placeholder="No min"
          (change)="handleChanges()"
          [(ngModel)]="projectROI"
          min="0"
          (focus)="selectAll($event)"
          inputmode="numeric"
        />
      </app-shared-input>
    </div>
  </div>
</ng-template>
